import { useEffect, useState } from 'react';
import { BiChevronDown, BiChevronUp } from 'react-icons/bi';

import { DownwardArrowIcon } from '../../../../../assets/icons/DownwardArrowIcon';
import { ErrorIcon } from '../../../../../assets/icons/ErrorIcon';
import { apiSensedia } from '../../../../../services/api-sensedia';
import { TableModalProps } from '../types/distribuicaoTypes';
import { getLeadsByUser } from '../utils/getLeadsByUser';
import { ButtonSubmit } from './ButtonSubimit';

export const TableModalEquipeDistribuicao = ({
  handleShowToast,
  disponiveis
}: any) => {
  const [loading, setLoading] = useState(false);

  const [loadingDistribuicao, setLoadingDistribuicao] = useState(false);
  const [inputValues, setInputValues] = useState([]);
  const [leadsToTransfer, setLeadsToTransfer] = useState(0);
  const [alertBox, setAlertBox] = useState(false);
  const [alertBoxText, setAlertBoxText] = useState('');
  const [payloadForDistribution, setPayloadForDistribution] = useState([]);
  const [openTable, setOpenTable] = useState(false);
  const [equipes, setEquipes] = useState([
    { id: '', total_leads: 0, nome: '', tipo_produto: '' }
  ]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const { data } = await apiSensedia.get(
        `/oportunidades-sulamerica/painel-leads/equipes/lista-redistribuicao`,
        {
          timeout: 0
        }
      );
      setEquipes(data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error('Erro ao buscar dados:', error);
    }
  };

  const handleDistribuicao = async () => {
    setLoadingDistribuicao(true);

    const filterInvalidValue = payloadForDistribution.filter((equipe) => {
      return equipe.quantidade > 0;
    });

    const limit = 500;
    let count = 1;
    const offset = 0;
    try {
      while (+disponiveis >= count) {
        const { data } = await apiSensedia.put(
          '/oportunidades-sulamerica/painel-leads/distribuicoes/automatica-equipes',
          filterInvalidValue,
          {
            params: { limit, offset },
            timeout: 0
          }
        );
        count = limit + offset;
      }
      await handleShowToast(
        'open',
        'Distribuição de leads iniciada, por favor acompanhe atualizando a tela de gestão até que a quantidade seja distribuída',
        'success'
      );
      setLoadingDistribuicao(false);
    } catch (err) {
      handleShowToast(
        'open',
        'Ocorreu um erro, favor tente novamente',
        'error'
      );
      setLoadingDistribuicao(false);
      console.log(err);
    }
  };

  const handleValueChange = (newValue: string, id: number) => {
    const parseIntDisp = parseInt(disponiveis);
    const parsedValue = parseInt(newValue, 10);

    const newInputValues = [...inputValues];
    newInputValues[id] = parsedValue;

    const sum = newInputValues.reduce((acc, currentValue) => {
      const numValue = currentValue !== undefined ? currentValue : 0;
      return acc + numValue;
    }, 0);
    setInputValues(newInputValues);
    handleLeadsToTransfer(sum, equipes[id]);

    let payload = {};

    payload = {
      id_equipe: equipes[id].id,
      quantidade: parsedValue
    };

    const newPayload =
      parsedValue <= parseIntDisp
        ? [...payloadForDistribution, payload]
        : payloadForDistribution;

    const uniqueMap = new Map();

    for (const obj of newPayload) {
      uniqueMap.set(obj.id_equipe, obj);
    }

    const finalPayload = Array.from(uniqueMap.values());

    setPayloadForDistribution(finalPayload);
  };

  const handleLeadsToTransfer = (value: number, id: any) => {
    const parseIntDisp = parseInt(disponiveis);

    if (value > parseIntDisp) {
      setAlertBox(true);
      setAlertBoxText('A quantidade não pode exceder ao número total de leads');
    } else {
      setLeadsToTransfer(parseIntDisp);
      setAlertBox(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <>
        <div className="tw-flex tw-flex-col md:tw-flex-row tw-justify-between tw-gap-[20px] tw-mt-[10px]">
          <button
            className=" disabled:tw-text-gray-300 tw-flex tw-items-center tw-justify-between tw-bg-[#FFFFFF] tw-w-full tw-h-[50px] tw-p-[16px] tw-rounded-md tw-border-[1px] tw-border-[#D4D7DE] tw-focus:outline-none tw-focus:shadow-outline"
            onClick={() => {
              setOpenTable(!openTable);
            }}
          >
            <span className="tw-text-start tw-overflow-hidden tw-whitespace-nowrap tw-text-ellipsis tw-max-w-[280px]">
              Selecionar Equipes
            </span>
            {openTable ? (
              <BiChevronUp className="tw-w-[24px] tw-h-[24px]" />
            ) : (
              <BiChevronDown className="tw-w-[24px] tw-h-[24px]" />
            )}
          </button>
        </div>
        {openTable && (
          <div className="tw-mt-[20px] tw-max-h-[360px] tw-overflow-y-auto tw-rounded-3xl tw-shadow-lg">
            {!loading ? (
              <table className="tw-w-[100%] tw-rounded-3xl ">
                <thead className="tw-sticky tw-top-0">
                  <tr className="tw-h-[100px] tw-bg-[#F5F5F5]">
                    <th className="tw-text-left tw-pl-[30px] tw-py-[25px] tw-rounded-tl-[24px]">{`Equipes (${
                      equipes?.length !== undefined ? equipes?.length : 0
                    })`}</th>
                    <th className="tw-pr-[30px] tw-py-[25px] tw-rounded-tr-[24px]">
                      {'Quantidade'}
                    </th>
                  </tr>
                </thead>
                <tbody className="">
                  {equipes?.map((item, index) => {
                    return (
                      <tr
                        key={index}
                        className={`${
                          index + 1 !== equipes.length &&
                          'tw-border-b-[1px] tw-border-[#D4D7DE]'
                        } `}
                      >
                        <td
                          className={`tw-bg-[#FFFFFF] tw-py-[20px] ${
                            index + 1 === equipes.length &&
                            'tw-rounded-bl-[25px]'
                          }  tw-text-left tw-flex tw-flex-col tw-gap-[5px]`}
                        >
                          <span className="tw-ml-[30px] tw-w-auto md:tw-w-[90%] tw-break-words tw-whitespace-pre-wrap">
                            {item?.nome}
                          </span>

                          <p
                            className={`tw-ml-[30px] tw-text-center tw-rounded-[7.5px] tw-p-[3.5px] tw-text-[#FFFFFF] tw-bg-[#001E64] tw-w-[5.5rem] }`}
                          >
                            {item?.tipo_produto}
                          </p>
                        </td>
                        <td
                          className={`tw-bg-[#FFFFFF] tw-px-[20px] md:tw-px-0 ${
                            index + 1 === equipes.length &&
                            'tw-rounded-br-[25px]'
                          } tw-text-center tw-font-bold tw-text-[1.25rem]`}
                        >
                          <input
                            type="number"
                            placeholder="0"
                            max={0}
                            min={0}
                            value={inputValues[index] || ''}
                            onChange={(event) =>
                              handleValueChange(event.target.value, index)
                            }
                            className="tw-text-center tw-w-full tw-max-w-[85px] tw-border-[1px] tw-border-stone-900 tw-rounded-md"
                          />
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <div className="tw-w-full tw-h-[250px] tw-flex tw-items-center tw-justify-center">
                <div className="spinner"></div>
              </div>
            )}
          </div>
        )}
        {alertBox && (
          <div
            className={`tw-bg-[#FACED2] tw-mt-[20px] tw-flex tw-justify-center tw-items-center tw-gap-[10px] tw-px-[16px] md:tw-px-[20px] tw-py-[16px] tw-rounded-[12px] tw-shadow-lg`}
          >
            <span>
              <ErrorIcon />
            </span>
            {alertBoxText}
          </div>
        )}
      </>
      <ButtonSubmit
        loading={loadingDistribuicao}
        condition={alertBox || loadingDistribuicao}
        label="Distribuir"
        onSubmit={handleDistribuicao}
      />
    </>
  );
};
